export default __webpack_public_path__ + "static/media/logo_adentis.5bb1a1c5.svg";